import { InputBaseComponentProps } from '@mui/material';
import { forwardRef } from 'react';

import { HBInputBaseRootStyle } from './HBInputBase.styles';

type IMaskInputProps = any;

export interface maskOptionsType extends Omit<IMaskInputProps, 'mask'> {
  mask: any;
  valueType?: 'maskedValue' | 'unmaskedValue';
}
export interface HBInputBaseProps extends Omit<InputBaseComponentProps, 'ref'> {
  maskoptions?: maskOptionsType;
}

export const HBInputBase = forwardRef((props: HBInputBaseProps, ref: any) => {
  const { maskoptions, value, onChange, ...otherProps } = props;
  const { mask, valueType = 'unmaskedValue' } = maskoptions || {};
  return (
    <HBInputBaseRootStyle
      {...{ mask, ...otherProps }}
      inputRef={ref}
      value={String(value ?? '')}
      onAccept={(value: any, input) =>
        onChange(
          {
            target: {
              value: valueType === 'maskedValue' ? value : input?.unmaskedValue,
            },
          },
          input?.unmaskedValue,
        )
      }
      definitions={{
        '0': /[0-9۰-۹]/,
        '*': /[A-Za-z0-9۰-۹]/,
      }}
    />
  );
});
HBInputBase.displayName = 'HBInputBase';
